import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Layout = styled.div``;
// @todo spinner colour from theme brand primary
const Loader = ({ isLoading, children }) =>
  isLoading ? (
    <Layout>
      <div className="loading-container">
        <div className="loader" />
        <div className="tnl-logo" />
      </div>
    </Layout>
  ) : (
    children
  );
Loader.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node
};
Loader.defaultProps = {
  isLoading: true,
  children: []
};

export default Loader;
